import CryptoJS from "crypto-js";
import FileTreeConfig from "./FileTreeConfig";

export function createChecksum(obj) {
  const jsonString = JSON.stringify(obj, (key, value) => {
    if (typeof value === "object" && value !== null && !Array.isArray(value)) {
      // Sort object keys
      return Object.keys(value)
        .sort()
        .reduce((sorted, k) => {
          sorted[k] = value[k];
          return sorted;
        }, {});
    } else if (Array.isArray(value)) {
      // Sort array items
      // return value.slice().sort((a, b) => JSON.stringify(a).localeCompare(JSON.stringify(b)));
    }
    return value;
  });

  const hash = CryptoJS.SHA256(jsonString).toString();
  return hash;
}

export function saveFile(response, fileName) {
  const blob = new Blob([response], { type: "application/octet-stream" });

  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = fileName;

  document.body.appendChild(link);

  link.click();

  document.body.removeChild(link);
}

export function extractVariables(inputString) {
  const regex = /{{range\s+(\w+)|{{(\w+)}}/g;

  const variableNames = new Set();
  let match;
  while ((match = regex.exec(inputString)) !== null) {
    const variableName = match[1] || match[2];
    if (variableName && variableName !== "end") {
      variableNames.add(variableName);
    }
  }
  return Array.from(variableNames);
}

// tree data functions
export const getEditData = (id, file) => {
  let flag = file?.can_edit;
  switch (file?.type) {
    default:
      return flag;
  }
};

export const getDeleteData = (id, file) => {
  let flag = file?.can_delete;
  switch (file?.type) {
    case "start":
    case "end":
      return false;
    default:
      return flag;
  }
};

export const getType = (name, file) => {
  switch (name) {
    case "recordsview":
    case "detailsview":
    case "activitycard":
    case "chart":
    case "progress-bar":
      return file?.table_type;
    default:
      return "";
  }
};

export function getFileInfo(name, file) {
  if (!file) {
    return {};
  }

  switch (name) {
    case "recordsview":
      if (file.config && file.config.layout) {
        return {
          table_id: file.config.layout.table_id || null,
          activity_id: file.config.layout.activity_id || null,
          info_tag: file.info_tag || [],
          is_offline: file.is_offline || false
        };
      }
      break;
    case "detailsview":
    case "activitycard":
      if (file.data) {
        return {
          table_id: file.data.table_id || null,
          activity_id: file.data.activity_id || null,
          info_tag: file.info_tag || []
        };
      }
      break;
    case "chart":
    case "progress-bar":
      if (file.config) {
        return {
          table_id: file.config.table_id || null,
          activity_id: file.config.activity_id || null,
          info_tag: file.info_tag || []
        };
      }
      break;
    case "Web Hook":
      return {
        table_id: file.sm_id || file.rdbms_id || null,
        version: file.version || "v1"
      };
    case "entity":
    case "statemachine":
      // case "desktop/screen":
      // case "mobile/screen":
      return {
        is_offline: file.is_offline || false
      };
    case "desktop/screen":
    case "mobile/screen":
      return {
        is_offline: file.is_offline || false,
        folder_info_tag: file.folder_info_tag || [],
        info_tag: file.info_tag || []
      };
    default:
      return {};
  }

  return {};
}

export function getFolderInfo(name, file) {
  if (!file) {
    return {};
  }
  switch (name) {
    case "statemachine":
      if (file) {
        return {
          is_offline: file.is_offline || false
        };
      }
      break;

    default:
      return {};
  }
}

export const getTreeClassName = (data) => {
  const type = data.field_type || data.type;
  switch (type) {
    case "activity":
      return "activity_folder";
    default:
      break;
  }
};

export const getSingleFolderWithFiles = (
  id,
  name,
  data,
  fileParent = "",
  folderParent = "",
  folderDeleteEdit = false,
  folderInsert = true,
  folderInsertType = "inline" //popup or inline
) => {
  const folder = FileTreeConfig.getFolderConfig(
    id,
    name,
    folderParent,
    folderDeleteEdit,
    folderInsert,
    true,
    folderInsertType
  );

  const allList = (data || []).map((file) => {
    // let flag = file?.can_delete;

    return FileTreeConfig.getFileConfig(
      file.id,
      file.name || (file.prefix ? file.prefix : "") + `${file.activity_label}.${file.display}`,
      fileParent || name,
      getDeleteData(id, file),
      getEditData(id, file),
      getFileInfo(name, file),
      getType(name, file)
    );
  });

  folder.items = allList;
  return folder;
};

export function reorderArrayFromOderKey(data) {
  if (!data) data = [];

  let zeroOrderStates = [];
  let otherStates = [];
  data.forEach((state) => {
    if (state.order === 0) {
      zeroOrderStates.push(state);
    } else {
      otherStates.push(state);
    }
  });
  otherStates.sort((a, b) => a.order - b.order);
  let reordered = otherStates.concat(zeroOrderStates);
  return reordered;
}
